import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IRootState } from "@/store";
import { IProcessTemplateState } from "@/store/modules/processTemplate/state";
import { ProcessTemplateMutations } from "@/store/modules/processTemplate/mutations";

export enum ProcessTemplateActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_PROCESS_TEMPLATE",
  FETCH_ONE = "FETCH_ONE_PROCESS_TEMPLATE",
  CREATE = "CREATE_PROCESS_TEMPLATE",
  UPDATE = "UPDATE_PROCESS_TEMPLATE",
  DELETE = "DELETE_PROCESS_TEMPLATE",
}

export const actions: ActionTree<IProcessTemplateState, IRootState> = {
  async [ProcessTemplateActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/documents/process-template/list", {
        params: params,
      });
      commit(ProcessTemplateMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("fetch process-template data provider error: ", error);
    }
  },
  async [ProcessTemplateActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(
        `/documents/process-template/view/${id}`
      );
      commit(ProcessTemplateMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch process-template one error: ", error);
    }
  },
  async [ProcessTemplateActions.CREATE]({ commit }, data: Document) {
    try {
      await baseApi.post("/documents/process-template/create", data);
    } catch (error) {
      console.log("process-template create error: ", error);
    }
  },
  async [ProcessTemplateActions.UPDATE]({ commit }, { id, data }) {
    try {
      await baseApi.put(`/documents/process-template/update/${id}`, data);
    } catch (error) {
      console.log("process-template update error:", error);
    }
  },
  async [ProcessTemplateActions.DELETE]({ commit }, id: string) {
    try {
      await baseApi.delete(`/documents/process-template/delete/${id}`);
    } catch (error) {
      console.log("process-template delete error:", error);
    }
  },
};
